import { ArrowUpRight } from "lucide-react";
import { useContent } from "../content-context";
import { Eyebrow, Reveal } from "./Reveal";

export default function ActivityPartner() {
  const { partner } = useContent();
  return (
    <section data-testid="activity-partner" className="border-t border-gold/15 bg-navy py-20 md:py-28">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <Reveal>
              <Eyebrow light>{partner.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display text-4xl font-medium leading-tight text-ivory md:text-5xl" data-testid="partner-heading">
                {partner.heading}
              </h2>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-5 max-w-xl text-sm font-light leading-relaxed text-ivory/80 md:text-base">
                {partner.copy}
              </p>
            </Reveal>
            <Reveal delay={0.26}>
              <a
                href={partner.website}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="partner-website"
                className="mt-9 inline-flex items-center gap-3 border border-gold px-8 py-4 text-xs font-semibold uppercase tracking-[0.22em] text-gold-2 transition-all duration-500 hover:bg-gold hover:text-navy"
              >
                {partner.websiteLabel} <ArrowUpRight className="h-4 w-4" />
              </a>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <ul className="flex flex-col gap-4">
              {partner.activities.map((a, i) => (
                <li key={a} className="flex items-center gap-4 border-b border-ivory/10 pb-4 text-base font-light text-ivory/85 md:text-lg">
                  <span className="text-[10px] tracking-widest2 text-gold">0{i + 1}</span>
                  {a}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
